import { FC } from 'react'
import CustomSelect from '../../UI/CustomSelect/CustomSelect'
import CustomInput from '../../UI/CustomInput/CustomInput'
import styles from '../EditClaimCardMainInformation.module.css'
import { discountType } from '../../../constants/constants'

interface FinancialInformationSectionProps {
  values: any
  handleChange: any
  setFieldValue: (field: string, value: any) => void
}

export const FinancialInformationSection: FC<FinancialInformationSectionProps> = ({
  values,
  handleChange,
  setFieldValue,
}) => {
  return (
    <div className={styles.sectionBlock}>
      <div className={styles.sectionTitle}>Финансовая информация</div>
      <div className={styles.sectionContent}>
        <div className={styles.cityBlock}>
          <div className={styles.leftBlock}>Сумма заказа</div>
          <div className={styles.rightBlock}>
            <div className={styles.companyBlock}>{values.price}</div>
          </div>
        </div>

        <div className={styles.cityBlock}>
          <div className={styles.leftBlock}>Тип скидки</div>
          <div className={styles.rightBlock}>
            <CustomSelect
              name='discountType'
              options={discountType}
              value={values.discountType}
              onChangeOption={(option) => setFieldValue('discountType', option)}
            />
          </div>
        </div>

        <div className={styles.cityBlock}>
          <div className={styles.leftBlock}>Скидка</div>
          <div className={styles.rightBlock}>
            {values.discountType === 'В процентах' ? (
              <CustomInput
                value={values.discountPercent}
                onChange={handleChange('discountPercent')}
                placeholder='Введите скидку в процентах'
              />
            ) : (
              <CustomInput
                value={values.discountAmount}
                onChange={handleChange('discountAmount')}
                placeholder='Введите скидку в рублях'
              />
            )}
          </div>
        </div>

        <div className={styles.cityBlock}>
          <div className={styles.leftBlock}>Тип сервисного сбора</div>
          <div className={styles.rightBlock}>
            <CustomSelect
              name='serviceFeeType'
              options={discountType}
              value={values.serviceFeeType}
              onChangeOption={(option) => setFieldValue('serviceFeeType', option)}
            />
          </div>
        </div>

        <div className={styles.cityBlock}>
          <div className={styles.leftBlock}>Сервисный сбор</div>
          <div className={styles.rightBlock}>
            {values.serviceFeeType === 'В процентах' ? (
              <CustomInput
                value={values.serviceFeePercent}
                onChange={handleChange('serviceFeePercent')}
                placeholder='Введите процент сервисного сбора'
              />
            ) : (
              <CustomInput
                value={values.serviceFeeAmount}
                onChange={handleChange('serviceFeeAmount')}
                placeholder='Введите сервисный сбор в рублях'
              />
            )}
          </div>
        </div>

        <div className={styles.cityBlock}>
          <div className={styles.leftBlock}>Тип пробкового сбора</div>
          <div className={styles.rightBlock}>
            <CustomSelect
              name='corkFeeType'
              options={discountType}
              value={values.corkFeeType}
              onChangeOption={(option) => setFieldValue('corkFeeType', option)}
            />
          </div>
        </div>

        <div className={styles.cityBlock}>
          <div className={styles.leftBlock}>Пробковый сбор</div>
          <div className={styles.rightBlock}>
            {values.corkFeeType === 'В процентах' ? (
              <CustomInput
                value={values.corkFeePercent}
                onChange={handleChange('corkFeePercent')}
                placeholder='Введите процент пробкового сбора'
              />
            ) : (
              <CustomInput
                value={values.corkFeeAmount}
                onChange={handleChange('corkFeeAmount')}
                placeholder='Введите пробковый сбор в рублях'
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
